import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CTAButton } from "./primitives";
import bannerImg from "@/assets/img/favorit-querformat.png";
import bannerPortraitImg from "@/assets/img/favorit-hochkant.png";

const navItems = [
  { label: "Ablauf", id: "ablauf" },
  { label: "Boni", id: "boni" },
  { label: "FAQ", id: "faq" },
];

const scrollToId = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -16 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const HeroNav = () => (
  <div className="relative z-20 mx-auto flex max-w-7xl items-center justify-between px-6 pt-8 md:px-12">
    <span
      data-testid="brand-logo"
      className="font-heading text-sm font-700 uppercase tracking-[0.4em] text-espresso"
      style={{ fontWeight: 700 }}
    >
      LIMONATA COACHING
    </span>
    <nav data-testid="anchor-nav" className="flex items-center gap-5 md:gap-8">
      {navItems.map((n) => (
        <a
          key={n.id}
          href={`#${n.id}`}
          onClick={scrollToId(n.id)}
          data-testid={`nav-link-${n.id}`}
          className="inline-flex min-h-[44px] items-center py-2 font-heading text-[11px] uppercase tracking-[0.25em] text-espresso/70 transition-colors duration-300 hover:text-espresso"
        >
          {n.label}
        </a>
      ))}
    </nav>
  </div>
);

const HeroBanner = ({ imgY }) => (
  <motion.div
    initial={{ opacity: 0, scale: 1.03, y: 28 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ duration: 1.1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
    style={{ y: imgY }}
    className="relative z-10 mx-auto mt-8 max-w-7xl px-4 sm:px-6 md:mt-12 md:px-12"
  >
    <img
      src={bannerImg}
      alt="Unverschämt Erfolgreich – Für einen Job, der sich nach Dir anfühlt. Ohne Abstriche. By Luisa Bergholz"
      data-testid="hero-banner-image"
      className="hidden w-full rounded-sm shadow-[0_40px_90px_-30px_rgba(62,39,35,0.45)] md:block"
    />
    <img
      src={bannerPortraitImg}
      alt="Unverschämt Erfolgreich – Für einen Job, der sich nach Dir anfühlt. Ohne Abstriche. By Luisa Bergholz"
      data-testid="hero-banner-image-mobile"
      className="mx-auto w-full max-w-md rounded-sm shadow-[0_40px_90px_-30px_rgba(62,39,35,0.45)] md:hidden"
    />
  </motion.div>
);

const HeroCTA = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 0.75, ease: [0.22, 1, 0.36, 1] }}
    className="relative z-20 mx-auto mt-10 flex max-w-7xl flex-col items-center gap-5 px-6 text-center md:mt-14"
  >
    <CTAButton variant="cognac" testId="hero-cta-button">
      Direkt buchen
    </CTAButton>
    <span className="font-heading text-xs uppercase tracking-[0.3em] text-espresso/70">
      6 monatiges Coaching- und Mentoring
    </span>
  </motion.div>
);

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], [0, 70]);

  return (
    <header
      ref={ref}
      data-testid="hero-section"
      className="hero-radial grain relative w-full overflow-hidden pb-16 md:pb-24"
    >
      {/* soft sun bloom top-left */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-[46vw] w-[46vw] rounded-full bg-[#FFF9DA] opacity-60 blur-[80px]" />
      <HeroNav />
      <HeroBanner imgY={imgY} />
      <HeroCTA />
    </header>
  );
}
